import { StreemApiDeviceSupportedVideoPlatforms } from '@streem/api';
import { ChimeRoom } from '@streem/sdk-chime-video';
export const buildTrackProvider = (callSettings, observables, isHostSession, roomId) => {
    const { isVideoProviderVerboseLoggingEnabled, videoPlatform, chimeNetworkAdaptationEnabled } = callSettings;
    if (videoPlatform === StreemApiDeviceSupportedVideoPlatforms.CHIME) {
        return new ChimeRoom({
            roomVideoCredentials: callSettings.roomVideoCredentials,
            remoteParticipantCapabilities: observables.remoteParticipantCapabilities,
            isHostSession,
            streemRoomId: roomId,
            chimeLowBandwidthOptimizationEnabled: callSettings.chimeLowBandwidthOptimizationEnabled,
            preferredVideoCodecs: callSettings.preferredVideoCodecs,
            isVideoProviderVerboseLoggingEnabled,
            chimeNetworkAdaptationEnabled,
        });
    }
    else {
        throw new Error('Invalid video platform');
    }
};
//# sourceMappingURL=track_provider_builder.js.map